export default {
	listing: {
		// What page we are on
		page: 1
	}
}
